// @flow

// Utils
import createReducer from 'fc-utils/createReducer'

// InitialState
import initialState from './initialState'

// Сonstants
import {
  IMPORT_JOBS,
  BRANCH,
} from './constants'

// Controller
import soilSamplingJobsCtrl from 'fc-ctrl-sampling-jobs'
import soilSamplingPointsCtrl from 'fc-ctrl-sampling-points'
import gridCtrl from 'hfty-ctrl-grid'

// Exports
export default createReducer(initialState, {
  ...soilSamplingJobsCtrl.reducers,
  ...soilSamplingPointsCtrl.reducers,
  ...gridCtrl.reducers,
  [IMPORT_JOBS]: (state: Object, payload: Object): Object => {
    return {
      ...state,
      [BRANCH]: {
        ...state[BRANCH],
        ...payload,
      },
    }
  },
})
